// extracted by mini-css-extract-plugin
export default {"References":"References_References__qymmi"};